import type { FirestoreEntity, Summary, WithId } from './entities';
import type { CommentCount } from './comment';
import type { PositionEntity2 } from './position2';

export interface ProjectEntity extends CommentCount {
  name: string;
  customerName: string | null;
  customerId: string | null;
  isActive: boolean;
  positions?: Record<string, PositionEntity2>;
  favorite: Record<string, boolean>;
  totalBilled?: number;
}

export type ProjectSummary = Summary;

export type Project = ProjectEntity & WithId;
export type FirestoreProject = FirestoreEntity<Project>;

export function mapProjectSummary(project: FirestoreProject) {
  return {
    id: project.id,
    displayName: project.data.name || 'No Displayname',
  };
}
